import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MovieCard from "../components/MovieCard";
import CustomHeading from "../components/CustomHeading";
import Loader from "../components/Loader";


import UseFetch from "../hooks/UseFetch";
import {
    getPopularMovies,
    getTopRatedMovies,
    getInTheatresMovies,
    getPopularTvSeries,
    getUpcomingMovies,
    getAnime,
} from "../services/api";

const CATEGORY_API_MAP = {
    movies: getPopularMovies,
    "top-rated": getTopRatedMovies,
    theatres: getInTheatresMovies,
    "tv-series": getPopularTvSeries,
    upcoming: getUpcomingMovies,
    anime: getAnime,
};

const CATEGORY_TITLE_MAP = {
    movies: "Popular Movies",
    "top-rated": "Top Rated Movies",
    theatres: "Now In Theatres",
    "tv-series": "Popular TV Series",
    upcoming: "Upcoming Movies",
    anime: "Anime Series",
};

const ViewAll = () => {
    const { category, page = 1 } = useParams();
    const navigate = useNavigate();

    const fetchFunction = CATEGORY_API_MAP[category];
    const title = CATEGORY_TITLE_MAP[category] || "Movies";

    const { data, loading, error } = UseFetch(fetchFunction, Number(page));

    // Handle pagination
    const currentPage = Number(page) || 1;
    const totalPages = data?.total_pages || 1;

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            navigate(`/${category}/${newPage}`);
        }
    };

    return (
        <div>
            <Navbar />

            <div className="container mx-auto px-4 py-8 min-h-[60vh]">
                <CustomHeading title={title} />

                {loading ? (
                    <Loader />
                ) : error ? (
                    <div className="text-center text-red-500 py-10">Error: {error}</div>
                ) : (
                    <>
                        {data?.results?.length ? (
                            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5 mb-8">
                                {data.results.map((movie) => (
                                    <MovieCard
                                        key={movie.id}
                                        id={movie.id}
                                        title={movie.title || movie.name}
                                        poster_path={movie.poster_path}
                                        vote_average={movie.vote_average}
                                        release_date={movie.release_date || movie.first_air_date}
                                        adult={movie.adult}
                                        type={category === "tv-series" || category === "anime" ? "tv" : "movie"}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="text-center text-gray-400 py-10">No results found.</div>
                        )}

                        {/* Pagination */}
                        <div className="flex justify-center items-center gap-2 mt-8">
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                className="px-3 py-1.5 rounded bg-pink-600 hover:bg-pink-400 duration-150 text-gray-200 disabled:opacity-50"
                            >
                                Prev
                            </button>
                            <span className="px-3 py-1 text-black dark:text-white">{currentPage} / {totalPages}</span>
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                className="px-3 py-1.5 rounded bg-pink-600 hover:bg-pink-400 duration-150 text-gray-200 disabled:opacity-50"
                            >
                                Next
                            </button>
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default ViewAll;